import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toastError } from '@components/Toast';

import { toggleCheckbox } from '@features/filter/static/filterUtil';

import { storeItemInGlobalFilter } from '@store/actions/FilterAction';

import ApiClient from '@lib/apiClient';

const CountryList = () => {
	const [countryList, setCountryList] = useState([]);
	const filterData = useSelector((store) => store.filterFieldStore);

	const dispatch = useDispatch();

	const fetchCountryList = () => {
		ApiClient.GET('getCountryListByUnits', 'SAMPLE_HOUSE')
			.then(({ data }) => {
				let lists = [];
				data.map((item) => lists.push({ id: item.id, name: item.name }));
				setCountryList(lists);
			})
			.catch(() => {
				toastError('Unable to fetch Country list!');
			});
	};

	useEffect(() => {
		fetchCountryList();
	}, []);

	const handleCheckbox = (e, title) => {
		let { value, checked, name } = e.target;
		let data = {
			name: 'developmentLocations',
			key: value,
			value: title,
			identifier: name,
			checked: checked
		};
		dispatch(storeItemInGlobalFilter(data));
	};

	const renderMarketList = () => {
		return countryList.map((item, index) => {
			return (
				<div className="form-group" key={`filter_country_${index}`}>
					<input
						type="checkbox"
						id={`country_${index}`}
						name={`country_${index}`}
						value={item.id}
						onChange={(e) => handleCheckbox(e, item.name)}
						checked={toggleCheckbox(filterData, 'developmentLocations', `country_${index}`)}
					/>
					<label htmlFor={`country_${index}`}>
						<span>{item.name}</span>
					</label>
				</div>
			);
		});
	};

	return (
		<div className="card">
			<div className="card-header" id="headingCountry">
				<h5 className="mb-0">
					<button
						className="btn btn-link collapsed"
						data-toggle="collapse"
						data-target="#collapseCountry"
						aria-expanded="false"
						aria-controls="collapseCountry"
					>
						Development location
					</button>
				</h5>
			</div>

			<div
				id="collapseCountry"
				className="collapse"
				aria-labelledby="headingCountry"
				data-parent="#accordion"
			>
				<div className="card-body">
					<div className="custom-chekbox">{renderMarketList()}</div>
				</div>
			</div>
		</div>
	);
};

export default CountryList;
